import orderSummaryStyles from 'components/Cart/OrderSummary/OrderSummary.module.scss';
import cx from 'classnames';
import { TextV2 } from 'components/TextV2/TextV2';
import React from 'react';
import { SUMMARY_SECTION_TEST_ID } from './SummarySection.const';

interface ISummarySectionProps {
  heading?: string;
  subheading: string;
  price: string;
  dataTestId?: string;
}

export const SummarySection: React.FC<ISummarySectionProps> = ({
  heading,
  price,
  subheading,
  dataTestId,
}) => (
  <section>
    {heading && (
      <TextV2 tagName="h4" variant="eyebrow" className={orderSummaryStyles.heading} value={heading} />
    )}
    <div
      className={cx(orderSummaryStyles.subheading, orderSummaryStyles.subheadingSpaced)}
      data-testid={dataTestId}
    >
      <TextV2
        data-testid={SUMMARY_SECTION_TEST_ID.subheading}
        variant="body"
        tagName="p"
        value={subheading}
        className={orderSummaryStyles.subheadingLabel}
      />
      <TextV2 data-testid={SUMMARY_SECTION_TEST_ID.price} variant="body" tagName="p" value={price} />
    </div>
  </section>
);
